'use strict';

require('./index').polyfill();



//////////////////
// WEBPACK FOOTER
// ../node_modules/es6-object-assign/auto.js
// module id = 21
// module chunks = 0